export default __webpack_public_path__ + "static/mexico-3d85d2fd1214cb099810f3bb71252feb.svg";